import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { BASE_PATH } from '../Constants/constants';
import { useCurrentUser } from '../hooks/useCurrentUser';

export function AuthGuard(): React.ReactElement {
  const loggedInUser = useCurrentUser();
  const location = useLocation();

  if (loggedInUser.id === 0) {
    return <Navigate to="/login" replace />;
  }

  if (location.pathname === '/') {
    return <Navigate to={`/${BASE_PATH}/${loggedInUser.id}`} replace />;
  }

  return <Outlet />;
}
